import { BucketImage } from "./BucketImage";

export enum RoomType {
  KITCHEN = "kitchen",
  LIVINGROOM = "livingroom",
  BEDROOM = "bedroom",
  CLOSET = "closet",
  BATHROOM = "bathroom",
  OTHER = "other",
}

export const roomTypes = {
  [RoomType.KITCHEN]: "Cucina",
  [RoomType.LIVINGROOM]: "Sala",
  [RoomType.BEDROOM]: "Camera da letto",
  [RoomType.CLOSET]: "Sgabuzzino",
  [RoomType.BATHROOM]: "Bagno",
  [RoomType.OTHER]: "Altro",
};

export type BuildingMediaBuildingData = {
  id: string;
  code: string;
};

export enum BuildingMediaType {
  DEFAULT_ROOM_PICTURE = 1,
  ROOM_PICTURE = 2,
  ROOM_ICON = 3,
}

export type BuildingRoomMetadata = {
  roomType?: RoomType;
};

export interface BuildingMedia {
  id: string;
  building: BuildingMediaBuildingData;
  mediaType: BuildingMediaType;
  image: BucketImage;
  roomMetadata?: BuildingRoomMetadata;
}
